import React from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import CustomInput from "components/CustomInput/CustomInput.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

import { CircularProgress } from '@material-ui/core';

import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import withStyles from "@material-ui/core/styles/withStyles";

import FileUpload from "components/CustomUpload/FileUpload.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import axios from "axios";
import { API_ROOT } from 'api-config';
import { SUPPORT_EMAIL } from "../../api-config";


const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  answerOptions: {
    paddingLeft: '30px'
  },
  exampleTrack: {
    color: 'red'
  },
  ...customSelectStyle,
  ...regularFormsStyle,
  ...loginPageStyle,
  ...sweetAlertStyle
};

class BatchMessage extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')

    this.state = {
      userId: userId,
      fees: [{ code: 'loading...', fee: 'loading...', freq: ''}],
      discount: 0,
      monthlyFee: 'loading...',
      feeFreqOptions: [],
      inputDisabled: true,
      submitFeesButtonDisabled: false,
      alert: null,
      messageType: 'email',
      messageText: '',
      messageSubject: '',
      messageChar: 0,
      messageMaxChar: '',
      batchMessageStatus: '',
      batchMessageStatusIndicator: ''
    };

  }
  componentDidMount() {
    this._isMounted = true;
  }


  changeField(event, field, validation) {
    var proceed = true
    if (validation === 'messageLength') {
      proceed = this.validateMessageLength(event.target.value)
    }
    if (field === 'messageType') {
      this.setMaxChar(event.target.value)
    }
    if (proceed) {
      this.setState({
        [field]: event.target.value
      })
    }
  }

  validateMessageLength(value) {
    var messageChar = value.length
    var returnValue;
    if (this.state.messageMaxChar) {
      if (messageChar <= this.state.messageMaxChar || messageChar < this.state.messageChar) {
        returnValue = true
      } else {
        messageChar = this.state.messageChar
        returnValue = false
      }
    } else {
      returnValue = true
    }
    this.setState({
      messageChar: messageChar
    })
    return returnValue
  }

  setMaxChar(value) {
    var messageMaxChar;
    if (value === 'SMS') {
      messageMaxChar = 300
    } else {
      messageMaxChar = ''
    }
    this.setState({
      messageMaxChar: messageMaxChar
    })
  }
  sendBatchMessage(file, filename) {
    if (file === '' || this.state.messageType === '' || this.state.messageText === '') {
      alert("Please enter a message, choose a message type, and upload a file with emails or phone numbers.")
    } else if (this.state.messageType === 'S' && this.state.messageChar > this.state.messageMaxChar) {
      alert("You have selected to send text messages, but the message length is greater than " + this.state.messageChar +
        " characters. Please update the message and send again.")
    } else {
      const statusIndicator = <CircularProgress size={20}/>
      this.setState({
        batchMessageStatusIndicator: statusIndicator,
        batchMessageStatus: 'uploading...'
      });

      const formData = new FormData();
      formData.append('file', file);
      formData.append('userId', this.state.userId);
      formData.append('messageText', this.state.messageText);
      formData.append('messageSubject', this.state.messageSubject);
      formData.append('messageType', this.state.messageType);
      axios.post(`${API_ROOT}/batchMessage/`, formData, { headers: getApiHeaders() })
        .then(res => this.handleBatchUploadResponse(res.data));
    }

  }

  handleBatchUploadResponse(res) {
    var batchMessageStatus;
    if (res.status && res.status === 'success') {
      batchMessageStatus = "We've queued your batch messages, and we'll send you an email when we've sent them all."
    } else {
      batchMessageStatus = "There was an error queuing your batch messages. Please try again, and if the issue continues, please email us at " + SUPPORT_EMAIL + "."
    }
    this.setState({
      batchMessageStatusIndicator: '',
      batchMessageStatus: batchMessageStatus
    });
    if (res.status && res.status === 'success') {
      this.setState({
        messageText: '',
        messageSubject: '',
        messageChar: 0
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div style={{width: '100%', align: 'center', height: '100%'}}>
        <GridContainer>
          {this.state.alert}
          <GridItem xs={12} sm={12}>
            <FormControlLabel
              control={
                <Radio
                  checked={this.state.messageType === "email"}
                  onChange={event => this.changeField(event, "messageType")}
                  value="email"
                  name="messageType"
                  aria-label="email"
                  icon={
                    <FiberManualRecord
                      className={classes.radioUnchecked}
                    />
                  }
                  checkedIcon={
                    <FiberManualRecord
                      className={classes.radioChecked}
                    />
                  }
                  classes={{
                    checked: classes.radio,
                    root: classes.radioRoot
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label="email"
            />
            <FormControlLabel
              control={
                <Radio
                  checked={this.state.messageType=== "SMS"}
                  onChange={event => this.changeField(event, "messageType")}
                  value="SMS"
                  name="messageType"
                  aria-label="SMS"
                  icon={
                    <FiberManualRecord
                      className={classes.radioUnchecked}
                    />
                  }
                  checkedIcon={
                    <FiberManualRecord
                      className={classes.radioChecked}
                    />
                  }
                  classes={{
                    checked: classes.radio,
                    root: classes.radioRoot
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label="text"
            />
          </GridItem>

          <GridItem xs={12} sm={12} style={this.state.messageType === 'email' ? {} : { display: 'none' }}>
            <CustomInput
              labelText="subject"
              type="text"
              id="messageSubject"
              fullWidth={true}
              inputProps={{
                onChange: event => this.changeField(event, "messageSubject"),
                value: this.state.messageSubject
              }}
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12}>
            <CustomInput
              labelText="message"
              type="text"
              id="messageText"
              multiline={true}
              rows="3"
              rowsMax="10"
              fullWidth={true}
              inputProps={{
                multiline: true,
                onChange: event => this.changeField(event, "messageText", 'messageLength'),
                value: this.state.messageText
              }}
              formControlProps={{
                fullWidth: true
              }}
            />
            <span style={this.state.messageMaxChar ? {} : { display: 'none' }}>
              {this.state.messageChar}/{this.state.messageMaxChar} characters
            </span>
          </GridItem>
          <GridItem xs={12} sm={12}>
            Please upload a csv file with a single column containing email addresses or phone numbers.
          </GridItem>
          <GridItem xs={12} sm={12}>
            <FileUpload
              uploadAction = {this.sendBatchMessage.bind(this)}
              uploadButtonName = "send batch message"
            />
          </GridItem>
          <GridItem xs={12} sm={12}>
            {this.state.batchMessageStatusIndicator} {this.state.batchMessageStatus}
          </GridItem>
        </GridContainer>
      </div>

    );
  }
}

export default withStyles(style)(BatchMessage);
